import { render, staticRenderFns } from "./AddTour.vue?vue&type=template&id=03ded282"
import script from "./AddTour.vue?vue&type=script&lang=js"
export * from "./AddTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports